import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";

import { BrandSearchResult } from "..";
import BrandCard from "../BrandCard";

interface CartDialogProps {
  open: boolean;
  onClose: () => void;
  savedBrands: BrandSearchResult[];
  isBrandLoading: (brand: BrandSearchResult) => boolean;
  addBrand: (brand: BrandSearchResult) => void;
  onScheduleEmails: () => void;
}

export default function CartDialog({
  open,
  onClose,
  savedBrands,
  isBrandLoading,
  addBrand,
  onScheduleEmails,
}: CartDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle component="div">
        <Typography variant="h6">
          Selected Brands ({savedBrands.length})
        </Typography>
      </DialogTitle>
      <DialogContent>
        {savedBrands.length === 0 ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="200px"
          >
            <Typography color="text.secondary">
              No brands selected yet. Add brands from your conversation to get
              started!
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={2}>
            {savedBrands.map((brand, i) => (
              <Grid key={i} item xs={12} sm={6} md={4}>
                <BrandCard
                  brand={brand}
                  isAdded={true}
                  isLoading={isBrandLoading(brand)}
                  addBrand={addBrand}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Close
        </Button>
        <Button
          onClick={onScheduleEmails}
          variant="contained"
          disabled={savedBrands.length === 0}
        >
          Schedule Emails ({savedBrands.length})
        </Button>
      </DialogActions>
    </Dialog>
  );
}
